module.exports = __webpack_public_path__ + "img/c08_unitscout_Normal_ua.539b540c.webp";